import { CalendarStateContext } from 'react-aria-components';
import { useContext } from 'react';
import { SelectField } from '../forms/controls/base-fields/SelectField';

export function MonthYearDropdowns() {
	const state = useContext(CalendarStateContext)!;
	const { month, year } = state.focusedDate;

	const months = Array.from({ length: 12 }, (_, i) => ({
		id: (i + 1).toString(),
		name: new Date(2024, i).toLocaleString('default', { month: 'long' })
	}));

	const currentYear = new Date().getFullYear();
	const years = Array.from({ length: 121 }, (_, i) => currentYear - 100 + i);

	return (
		<>
			<SelectField
				label="Month"
				hideLabel
				value={month.toString()}
				onChange={value => state.setFocusedDate(state.focusedDate.set({ month: Number(value) }))}
				items={months}
			/>
			<SelectField
				label="Year"
				hideLabel
				value={year.toString()}
				onChange={value => state.setFocusedDate(state.focusedDate.set({ year: Number(value) }))}
				items={years.map(y => ({ id: y.toString(), name: y.toString() }))}
			/>
		</>
	);
}
